module.exports = __webpack_public_path__ + "img/zt_pic7.af3884cd.png";